// 设计稿基准尺寸
const designWidth = 1920
const designHeight = 1080

// 1080p下的基准字体大小（16px）
const baseFontSize = 16

// 计算字体大小的函数
export const calculateFontSize = () => {
  const width = window.innerWidth
  const height = window.innerHeight
  const widthRatio = width / designWidth
  const heightRatio = height / designHeight
  const ratio = Math.min(widthRatio, heightRatio)

  // 设置根元素字体大小，用于rem单位计算
  document.documentElement.style.fontSize = `${ratio * baseFontSize}px`
}

// 初始化自适应
export const initAdaptive = () => {
  calculateFontSize()
  window.addEventListener('resize', calculateFontSize)
}

// 清理事件监听
export const cleanupAdaptive = () => {
  window.removeEventListener('resize', calculateFontSize)
}
